export default "__VITE_ASSET__CtyIg9Hh__"